import React from 'react';
import SurveyCardSkeleton from './FormCardSkeleton';

const SurveyListPageSkeleton = ({ showFullPage = false }) => {
  if (showFullPage) {
    return (
      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-3">
          <div className="h-32 bg-gray-200 rounded-xl animate-pulse" />
          <div className="h-32 bg-gray-200 rounded-xl animate-pulse" />
          <div className="col-span-2 h-24 bg-gray-200 rounded-xl animate-pulse" />
        </div>
        <div>
          <div className="flex justify-between items-center mb-4 px-1">
            <div className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
            <div className="h-8 w-20 bg-gray-200 rounded-lg animate-pulse" />
          </div>
          <div className="grid grid-cols-1 gap-4">
            <SurveyCardSkeleton />
            <SurveyCardSkeleton />
            <SurveyCardSkeleton />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6">
      <SurveyCardSkeleton />
      <SurveyCardSkeleton />
      <SurveyCardSkeleton />
    </div>
  );
};

export default SurveyListPageSkeleton;